<div class="main">
    <app-scrollup></app-scrollup>
    <app-header-one></app-header-one>
    <app-breadcrumb-faq></app-breadcrumb-faq>
    <app-faq-one></app-faq-one>
    <app-download></app-download>
    <app-contact></app-contact>
    <app-footer-one></app-footer-one>
</div>